export default __webpack_public_path__ + "static/148-e29d8bd30c49eb3049f78d038a56976e.jpg";